if (!window.hasOwnProperty('appModules')) {
    window.appModules = {};
}

window.appModules.Constructor = function () {
    var el = this;
    var initialized = false;
    var windowWidth = $(window).width();
    var SOUVENIR_GROUP_ID = 3;
    el.CALENDAR_GROUP_ID = 6;

    el.isCheckingOnloadStatus = false;

    el._parent = this;
    el.MM_IN_PIXELS = 2.54 / (300 / 10);
    el.WORKAREA_WIDTH = 800;

    el.productGroupId = SOUVENIR_GROUP_ID;

    el.svgRoot = false;
    el.selectType = '';
    el.selectId = 0;
    el.selectWorkareaId = 0;
    el.workData = {};

    el.isTransforming = false;
    el.showFastOrder = 0;
    el.homeLink = '/';
    el.user = {};

    el.isTouchMoving = false;

    function initModules() {
        window.Workarea.prototype = el;
        window.UpImages.prototype = el;
        window.Select.prototype = el;
        window.Calculator.prototype = el;
        window.ImageBackground.prototype = el;
        window.ImageCell.prototype = el;
        window.Project.prototype = el;
        window.Layer.prototype = el;
        window.Hotkeys.prototype = el;
        window.TransformView.prototype = el;
        window.History.prototype = el;
        window.Format.prototype = el;
        window.Cell.prototype = el;
        window.BorderCell.prototype = el;
        window.Grid.prototype = el;
        window.Text.prototype = el;
        window.Color.prototype = el;
        window.Size.prototype = el;
        window.Themes.prototype = el;
        window.Decors.prototype = el;
        window.Mask.prototype = el;
        window.Template.prototype = el;
        window.Language.prototype = el;
        window.CalendarGrid.prototype = el;
        window.CalendarText.prototype = el;
        window.CalendarSelect.prototype = el;
        window.CalendarBackground.prototype = el;
        window.Preview.prototype = el;

        el.workarea = new window.Workarea();
        el.upImages = new window.UpImages();
        el.calculator = new window.Calculator();
        el.selection = new window.Select();
        el.background = new window.ImageBackground();
        el.image = new window.ImageCell();
        el.project = new window.Project();
        el.layer = new window.Layer();
        el.hotkeys = new window.Hotkeys();
        el.notice = new window.Notice();
        el.transform = new window.TransformView();
        el.history = new window.History();
        el.format = new window.Format();
        el.cell = new window.Cell();
        el.borderCell = new window.BorderCell();
        el.grid = new window.Grid();
        el.text = new window.Text();
        el.color = new window.Color();
        el.size = new window.Size();
        el.themes = new window.Themes();
        el.decors = new window.Decors();
        el.mask = new window.Mask();
        el.template = new window.Template();
        el.language = new window.Language();
        el.calendarGrid = new window.CalendarGrid();
        el.calendarText = new window.CalendarText();
        el.calendarSelect = new window.CalendarSelect();
        el.calendarBackground = new window.CalendarBackground();
        el.preview = new window.Preview();

        window.Upload.prototype = el;
        el.upload = new Upload({
            upload_url: window.requestUrls.image.upload,
            ref: 'image',
            mime_types: '',
            multipart_params: { projectID: window.bookSid.split("_")[0] },
            fileUploaded: function (file) {
                el.upImages.add(file);
                el.calendarBackground.checkUpload(file);
            },
            uploadComplete: function () {
                el.upImages.autoDistribution();
                el.showContainer('main-page');
            }
        });

        initialized = true;
    }

    function initEvents() {
        $('body')
            .on('touchstart', function () {
                el.isTouchMoving = false;
            })
            .on('mousemove touchmove', el.continueOperationsElement)
            .on('mouseup touchend', el.endOperationsElement);

        $(document).on('click', '.dropdown-menu li a', function () {
            $(this).parents('.btn-group').find('.dropdown-toggle').html($(this).text() + ' <span class="caret"></span>');
        });

        $(document).on('click', '.js-step-shopcart', function () {
            if (!el.workarea.isExistData(el.selectWorkareaId)) {
                el.dialog.show('message', { message: Yii.t('You need to upload an image to place an order') });
                return;
            }
            el.text.removeDefaultTexts();

            if (el.showFastOrder) {
                el.dialog.show('fast_order', { user: el.user, homeLink: el.homeLink });
            } else {
                el.shopcart();
            }
        });

        $(window).resize(function () {
            if ($(window).width() !== windowWidth) {
                windowWidth = $(window).width();

                if (!$('#main-page').hasClass('invisible')) {
                    el.workarea.render();
                }
            }
        });
    }

    el.init = function () {
        el.loader.show(Yii.t('Loading constructor data...'));
        $.getJSON(window.requestUrls.init + window.categoryUrl + '/' + window.productId)
            .done(function (response) {
                initModules();
                initEvents();

                el.category = response.category;
                el.description = response.description;
                el.product = response.product;
                el.companyProduct = response.companyProduct;

                el.text.fonts = response.fonts;
                el.calendarText.fonts = response.fonts;
                el.format.items = response.formats;
                el.workarea.workareas = response.workareas;
                el.workarea.workarea_formats = response.workarea_formats;
                el.calculator.prices = response.prices;
                el.calculator.count = response.count;
                el.calculator.priceGroupId = response.price_group_id;
                el.calculator.currency = response.currency;
                el.color.items = response.colors;
                el.color.availables = response.company_colors;
                el.size.items = response.sizes;
                el.size.availables = response.company_sizes;
                el.themes.data = response.themes;
                el.decors.data = response.decors;
                el.mask.data = response.masks;
                el.borderCell.data = response.frames;
                el.template.groups = response.template_groups;
                el.template.items = response.templates;
                el.calendarGrid.data = response.calendar_grids;
                el.calendarGrid.monthsList = response.months;
                el.calendarGrid.daysweekList = response.daysweek;
                el.grid.items = response.grids;
                el.grid.cells = response.grid_cells;
                el.showFastOrder = parseInt(response.show_fast_order);
                el.user = response.user;
                el.homeLink = response.home_link;
                el.projectsPath = response.projects_path;

                window.bookConstructor = el; //compabality
                el.project.load(window.bookSid);
                $('[data-toggle="popover"]').popover({ html: true });
                el.loader.hide();
            })
            .fail(function () {
                el.loader.hide();
                alert(Yii.t('Souvenir constructor data loading error. \nReload the page or check back later'));
            });
    };

    el.generateShopCartData = function () {
        var name = el.product.name;
        if (el.companyProduct !== undefined && el.companyProduct.name !== null && el.companyProduct.name.length > 0) {
            name = el.companyProduct.name;
        }

        if (parseInt(el.workData.color_id) !== 0) {
            name += ' ' + el.color.current.name;
        }

        if (parseInt(el.workData.size_id) !== 0) {
            name += ' ' + el.size.current.letter;
        }

        var data = {
            product_group_id: SOUVENIR_GROUP_ID,
            name: name,
            items: {
                project_id: el.project.current.id,
                count: el.calculator.count
            }
        };

        data.items = JSON.stringify(data.items);
        return data;
    };

    el.shopcart = function () {
        el.project.save(function () {
            var data = el.generateShopCartData();

            el.request.post('/shopcart/items', data, function (response) {
                if (response.hasOwnProperty('error')) {
                    alert(response.error.description);
                    return false;
                }

                el.isCheckingOnloadStatus = false;

                window.location.href = '/shopcart';
            }, 'json');
        });
    };

    el.continueOperationsElement = function (event) {
        el.isTouchMoving = true;
        if (initialized && el.isTransforming) {
            el.background.move(event);
            el.image.move(event);
            el.cell.move(event);
            el.cell.resize(event);
            el.cell.rotate(event);
            el.text.move(event);
            el.text.rotate(event);
            el.decors.move(event);
            el.decors.resize(event);
            el.decors.rotate(event);
            el.calendarText.move(event);
            el.calendarText.rotate(event);
            el.calendarBackground.move(event);
        }
    };

    el.endOperationsElement = function () {
        if (initialized && el.isTransforming) {
            el.isTransforming = false;

            el.background.endMove();
            el.image.endMove();
            el.cell.endMove();
            el.cell.endResize();
            el.cell.endRotate();
            el.text.endMove();
            el.text.endRotate();
            el.decors.endMove();
            el.decors.endResize();
            el.decors.endRotate();
            el.calendarText.endMove();
            el.calendarText.endRotate();
            el.calendarBackground.endMove();
        }
    };

    el.checkUnload = function (e) {
        if (el.isCheckingOnloadStatus) {
            e = e || window.event;

            el.project.save();

            e.cancelBubble = true;
            e.returnValue = Yii.t('When you exit, your project may not be saved.');

            if (e.stopPropagation) {
                e.stopPropagation();
                e.preventDefault();
            }
        }
    };

    el.showContainer = function (name) {
        $('.page').addClass('invisible');
        $('#' + name).removeClass('invisible');

        if (name === 'upload-page') {
            el.upload.computer.init();
            $('.upload-hide').removeClass('hide');
        }

        if (name === 'main-page') {
            el.upImages.render();
            el.workarea.render();
            el.preview.render();
        }
    };

    el.init();
    window.onbeforeunload = el.checkUnload;
};

if (window.hasOwnProperty('app')) {
    app.initModule('constructor', window.appModules.Constructor);
}
